import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from 'swiper';
import { Link } from 'react-router-dom';
import { Swiper, SwiperWrapper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import useGa from 'hooks/useGa';

const Tabs = (props) => {
    const gaTracking = useGa();
    const location = useLocation();
    const { className, style, defaultValue, value, to, onChange, children } = props;
    const tabList = React.Children.toArray(children);

    useEffect(() => {
        if(location.hash === ""){
            onChange(defaultValue);
        }else{
            onChange(location.hash);
        }
    }, [location.hash, defaultValue]);

    return (
        <div className="tab-list">
            <Swiper
                modules={[Navigation]}
                slidesPerView="auto"
                navigation
                className="serial-number-swiper"
            >
                <SwiperSlide className={`${className ? ` ${className}` : ''}${value === "#exchange" ? ` active` : ''}`} onClick={() => gaTracking("exchange-record")}>
                    <Link to="/serial-number#exchange" className="serial-number-link">
                        <div>序號明細</div>
                    </Link>
                </SwiperSlide>
                <SwiperSlide className={`${className ? ` ${className}` : ''}${value === "#giveaway" ? ` active` : ''}`} onClick={() => gaTracking("giveaway-record")}>
                    <Link to="/serial-number#giveaway" className="serial-number-link">
                        <div>兌換紀錄</div>
                    </Link>
                </SwiperSlide>
                <SwiperSlide className={`${className ? ` ${className}` : ''}${value === "#vote" ? ` active` : ''}`} onClick={() => gaTracking("vote-record")}>
                    <Link to="/serial-number#vote" className="serial-number-link">
                        <div>投票紀錄</div>
                    </Link>
                </SwiperSlide>
            </Swiper>
        </div>
    )
}

export default Tabs;